export default function _productPage() {

    const PRODUCT_PAGE_COMPONENT = '[data-pnp-component="product-page"]';

    function initImageZoom(productPageWrapper) {
        const modal = productPageWrapper.querySelector(".image-modal");
        const img = productPageWrapper.querySelector(".product-image img");
        const modalImg = modal.querySelector(".zoomed-image");
        const captionText = modal.querySelector(".caption");
        const closeBtn = modal.querySelector(".close");

        if (img) {
            img.addEventListener("click", function() {
                modal.style.display = "block";
                modalImg.src = this.src;
                captionText.innerHTML = this.alt;
            });
        }

        if (closeBtn) {
            closeBtn.addEventListener("click", function() {
                modal.style.display = "none";
            });
        }

        // Close modal if clicking outside of the image
        window.addEventListener("click", function(event) {
            if (event.target === modal) {
                modal.style.display = "none";
            }
        });
    }

    function initViewMore(productPageWrapper) {
        const viewMoreButton = productPageWrapper.querySelector(".view-more a");
        const productTable = productPageWrapper.querySelector(".product-table");

        if (viewMoreButton && productTable) {
            const rows = Array.from(productTable.querySelectorAll("tbody tr"));
            const initiallyVisibleRowsCount = 5;
            let isExpanded = false;

            // Set initial visibility of rows
            rows.forEach((row, index) => {
                if (index >= initiallyVisibleRowsCount) {
                    row.classList.add('hidden-row'); // Add a class to hide rows
                }
            });

            viewMoreButton.addEventListener("click", (e) => {
                e.preventDefault(); // Prevent default link behavior
                if (isExpanded) {
                    // Collapse rows and show 'View More'
                    rows.forEach((row, index) => {
                        if (index >= initiallyVisibleRowsCount) {
                            row.classList.add('hidden-row'); // Hide the rows again
                        }
                    });
                    viewMoreButton.textContent = "View More";
                } else {
                    // Expand rows and show 'View Less'
                    rows.forEach((row) => {
                        row.classList.remove('hidden-row'); // Show all rows
                    });
                    viewMoreButton.textContent = "View Less";
                }
                isExpanded = !isExpanded; // Toggle the expanded state
            });
        }
    }

    function setupImageSwitcher(mainImageSelector, secondaryImageSelector) {
        document.addEventListener("DOMContentLoaded", function() {
            const mainImage = document.querySelector(mainImageSelector);
            const secondaryImages = document.querySelectorAll(secondaryImageSelector);

            secondaryImages.forEach((image) => {
                image.addEventListener("click", () => {
                    const currentMainImageSrc = mainImage.src;
                    const clickedImageElement = image; // Store the image element in a variable
                    const clickedImageSrc = clickedImageElement.src;

                    // Update the main image src with the clicked image src
                    mainImage.src = clickedImageSrc;

                    // Update the clicked image src with the original main image src
                    clickedImageElement.src = currentMainImageSrc;
                });
            });
        });
    }

    setupImageSwitcher(".main-pdp-img", ".secondary-pdp-img");

    function initializeProductPage(item) {
        initImageZoom(item);
        initViewMore(item);
    }

    const ProductComponents = document.querySelectorAll(PRODUCT_PAGE_COMPONENT);

    ProductComponents.forEach((item) => {
        const productPageItem = item; // Create a new variable

        if (!productPageItem.dataset.productPageInitialized) {
            productPageItem.dataset.productPageInitialized = 'true';
            initializeProductPage(productPageItem);
        }
    });
}

_productPage();